import { render } from "./RatingButton.vue?vue&type=template&id=5a3a901e"
import script from "./RatingButton.vue?vue&type=script&lang=js"
export * from "./RatingButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__